import { Interview } from '@spoken/interviews/models';
import { InterviewsRepository } from '@spoken/interviews/state';
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { filter, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class InterviewResolver implements Resolve<Interview> {
	private _interviewsRepository = inject(InterviewsRepository);

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Interview> {
		return this._interviewsRepository.store.getObjectById$$$(route.paramMap.get('interviewId') ?? '', true).$.pipe(filter((i) => !!i));
	}
}
